export default __webpack_public_path__ + "static/media/arrow_circle_up_black.44d81788.svg";